import HomeTemplate from '../../templates/Home';
import {compose} from 'redux';
import {connect} from 'react-redux';
import * as Actions from '../../modules/Home/actions';

const mapStateToProps = state => {
  return state
};

const mapDispatchToProps = dispatch => {
  return {
    fetchQuestions() {
      dispatch(Actions.fetchQuestions())
    },
    selectAnswer(questionId, type) {
      dispatch(Actions.selectAnswer(questionId, type))
    },
  }
};

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(HomeTemplate);